export type T_ClientTraceRateDecision =
  | { allowed: false }
  | { allowed: true; droppedSinceLast: number };

export class C_ClientTraceRateLimiter {
  private dropped = 0;
  private emitted = 0;
  private windowStartedMs = 0;

  public constructor(private readonly limitPerSecond: number) {}

  public consume(nowMs: number): T_ClientTraceRateDecision {
    if (nowMs - this.windowStartedMs >= 1_000) {
      this.emitted = 0;
      this.windowStartedMs = nowMs;
    }
    if (this.emitted >= this.limitPerSecond) {
      this.dropped += 1;
      return { allowed: false };
    }

    this.emitted += 1;
    const droppedSinceLast = this.dropped;
    this.dropped = 0;
    return { allowed: true, droppedSinceLast };
  }

  public reset(nowMs: number): void {
    this.dropped = 0;
    this.emitted = 0;
    this.windowStartedMs = nowMs;
  }
}
